export default __webpack_public_path__ + "static/media/contact-email.af169813.png";